export default __webpack_public_path__ + "static/media/keg.a245469a.png";